import { Fade } from "react-awesome-reveal";
import SocialLinks from "../../../general/socialLinks/SocialLinks";
import { FaPhone } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { FaLocationDot } from "react-icons/fa6";

export default function ContactInfo() {
  return (
    <div className="flex-1 space-y-6">
      <h3 className="text-2xl">Contact Info</h3>

      {/* *********************************************************************************************************** */}

      {/* animation */}
      <Fade cascade damping={0.1}>
        <ul className="leading-8">
          <li className="flex items-center gap-2">
            <span>
              <FaPhone className="text-primary-green" />
            </span>
            +201550859246
          </li>
          <li className="flex items-center gap-2">
            <span>
              <MdEmail className="text-primary-green" />
            </span>
            ali.m.elshoraa@gmail.com
          </li>
          <li className="flex items-center gap-2">
            <span>
              <FaLocationDot className="text-primary-green" />
            </span>
            Cairo/Egypt
          </li>
        </ul>
      </Fade>

      {/* *********************************************************************************************************** */}

      {/* social media links */}
      <SocialLinks />
    </div>
  );
}
